import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';
import { InteractiveBarData } from './interactive-bar.model';

@Component({
    selector: "cv-interactive-bar",
    templateUrl: "./interactive-bar.component.html",
    styleUrls: ["./interactive-bar.component.scss"],
})
export class InteractiveBarComponent implements AfterViewInit {
    @Input() forceStatusBreakdownView = false;

    @ViewChild("interactiveBar", { static: false }) interactiveBar: ElementRef;
    @ViewChild("current", { static: false }) currentStatus: ElementRef;
    @ViewChild("breakdown", { static: false }) statusBreakdown: ElementRef;
    @ViewChild("tab", { static: false }) barTab: ElementRef;

    private initialized = false;
    private _data: InteractiveBarData = null;
    private hovering = false;
    private tooltipSet = false;

    get data() {
        return this._data;
    }

    @Input() set data(data: InteractiveBarData) {
        this._data = data;
        if (isNaN(this._data.percent)) this._data.percent = 0;
        else if (this._data.percent < 0) this._data.percent = 0;
        else if (this._data.percent > 100) this._data.percent = 100;
        this.tooltipSet = false;
    }

    ngAfterViewInit(): void {
        this.initialized = true;
        if (!this.forceStatusBreakdownView) return;
        this.mouseover(// Show breakdown view in the Objective Details Modal
            this.currentStatus.nativeElement,
            this.statusBreakdown.nativeElement,
            this.barTab.nativeElement
        );
    }

    public mouseover(current: HTMLElement, breakdown: HTMLElement, tab: HTMLElement): void {
        if (this._data.segments.length < 2) return;
        if (this.hovering) return;
        this.hovering = true;

        this.alignTooltips(breakdown);

        $(current).animate({
            opacity: 0
        }, {duration: 400, queue: false}).css('display', 'none');
        $(breakdown).animate({
            opacity: 1
        }, {duration: 400, queue: false}).css('display', 'flex');

        $(tab).animate({
            left: this._data.percent + "%"
        }, {duration: 400, queue: false});
    }

    public mouseleave(current: HTMLElement, breakdown: HTMLElement, tab: HTMLElement): void {
        if (this._data.segments.length < 2) return;
        if (this.forceStatusBreakdownView || !this.hovering) return;
        this.hovering = false;

        $(breakdown).animate({
            opacity: 0
        }, {duration: 400, queue: false}).css('display', 'none');
        $(current).animate({
            opacity: 1
        }, {duration: 400, queue: false}).css('display', 'flex');

        $(tab).animate({
            left: "50%"
        }, {duration: 400, queue: false});
    }

    private alignTooltips(breakdown: HTMLElement): void {
        $(breakdown).css({
            display: 'flex',
            opacity: 1,
            height: 0,
            overflow: 'hidden'
        });

        var segments = $(breakdown).children('.cv-interactive-bar-segment');
        var tooltips = $(breakdown).find('.cv-interactive-bar-tooltip');
        var tails = $(breakdown).find('.cv-interactive-bar-tooltip-tail');

        for (var i = 0; i < this.data.segments.length - 1; i++) {
            var tooltipLeft = (segments[i + 1].offsetLeft - 1) - (tooltips[i].offsetWidth / 2);

            // Get positions of the tooltips
            if ((segments[i + 1].offsetWidth - 3) / 2 < tooltips[i].offsetWidth / 2) {
                tooltipLeft += ((segments[i + 1].offsetWidth - 3) / 2) - (tooltips[i].offsetWidth / 2);
            }

            if (i != this.data.segments.length - 2 && (segments[i + 2].offsetWidth - 3) / 2 < tooltips[i].offsetWidth / 2) {
                tooltipLeft += ((segments[i + 2].offsetWidth - 3) / 2) - (tooltips[i].offsetWidth / 2);
            }

            if (i != 0) {
                var prevTooltipRight = tooltips[i - 1].offsetLeft + tooltips[i - 1].offsetWidth;
                if (tooltipLeft <= prevTooltipRight) {
                    tooltipLeft = prevTooltipRight + 3;
                }
            }

            var tooltipRight = tooltipLeft + tooltips[i].offsetWidth;

            // Get positions of the tooltip tails
            var tailLeft = (segments[i + 1]).offsetLeft - 1 - (tails[i].offsetWidth / 2);
            if (tooltipLeft > tailLeft) {
                tailLeft = tooltipLeft;
            }
            if (tooltipRight < tailLeft + tails[i].offsetWidth) {
                tailLeft = tooltipRight - tails[i].offsetWidth;
            }

            // Apply changes
            $(tooltips[i]).css({
                'left': tooltipLeft,
                'right': 'auto',
            });

            $(tails[i]).css({
                'left': tailLeft,
            });
        }

        // Change tootip style according to size and tail location
        for (var i = 0; i < this.data.segments.length - 1; i++) {
            var borderRadius = '5px';
            var borderWidth = '10px 10px 0';

            var tooltipLeft = tooltips[i].offsetLeft;
            var tailLeft = tails[i].offsetLeft;

            // If tooltip is small
            if (tooltips[i].offsetWidth < 30) {
                borderRadius = '0px';
                tailLeft -= 1;
            }
            // If tail is at left
            else if (tailLeft - tooltipLeft < 5) {
                borderRadius = '5px 5px 5px 0';

                if (!tooltips[i + 1] || tailLeft + 8 + tooltips[i].offsetWidth < tooltips[i + 1].offsetLeft - 3) {
                    borderWidth = '10px 10px 0 0';
                    tailLeft += 8;
                    tooltipLeft = tailLeft;
                }
            }
            // If tail is at right
            else if ((tooltipLeft + tooltips[i].offsetWidth) - (tailLeft + 20) < 5) {
                borderRadius = '5px 5px 0 5px';

                if (i == 0 || tooltipLeft - 8 > tooltips[i - 1].offsetLeft + tooltips[i - 1].offsetWidth + 3) {
                    borderWidth = '10px 0 0 10px';
                    tooltipLeft -= 8;
                    tailLeft += 1;
                    tailLeft = tooltipLeft + tooltips[i].offsetWidth - 10;
                }
            }

            // Apply changes
            $(tooltips[i]).css({
                'left': tooltipLeft,
                'right': 'auto',
                'border-radius': borderRadius,
            });

            $(tails[i]).css({
                'left': tailLeft,
                'border-width': borderWidth
            });
        }

        $(breakdown).css({
            display: 'none',
            opacity: 0,
            height: 10,
            overflow: 'initial'
        });

        this.tooltipSet = true;
    }
}
